import { getCategoryId } from "../../state/modules/category";
import sdkProvider from "../sdkProvider";
import { getFeatures } from "../../featuresStore";

const ENABLED_CATEGORY_IDS = [51163, 51164];

const newInRedirect = async ({ state }) => {
  const categoryId = getCategoryId(state);

  if (!ENABLED_CATEGORY_IDS.includes(categoryId)) {
    return;
  }

  const loyaltyAvailable = await isLoyaltyAvailable();
  if (!loyaltyAvailable) {
    return;
  }

  const { decisions } = getFeatures() || {};
  const loyaltyNewInExperimentEnabled = Boolean(
    decisions?.["loyalty-new-in-today-lock-product"]
  );
  if (loyaltyNewInExperimentEnabled) {
    return;
  }

  const identitySdk = await sdkProvider("identity");
  const isAuthenticated = await identitySdk.customer.isAuthenticated();

  if (!isAuthenticated) {
    identitySdk.login();

    return true;
  }
};

const isLoyaltyAvailable = async () => {
  try {
    const loyaltySdk = await sdkProvider("loyalty");

    return await loyaltySdk.isLoyaltyAvailable();
  } catch (error) {
    return false;
  }
};

export default newInRedirect;
